export default class Product {

    constructor(options) {
        this.name = options.name;
        this.productCode = options.productCode;
        this.description = options.description || null;
        this.basicPrice = typeof options.basicPrice !== undefined ? Number(options.basicPrice) : null;
        this.discount = options.discount || 0;
        this.category = options.category || null;
        this.stock = options.stock || null ;
        this.box  = options.box;
        this.fpa = options.fpa || 0.24;
        this.offers = {}

    }

    static zeroPadNumber(number, padding) {
        if(number === undefined)return "";
        if(padding === undefined) return number;
        let  mNumber = Number(number);
        let stringNum = mNumber.toFixed(3);
        return Number(stringNum);
    }

    static toPercent(decimal, padding) {
        if(decimal === undefined || padding === undefined) return "";
        return  (decimal*100).toFixed(0) +"%";
    }

    addOffer(name, ammount, isOn) {
        this.offers[name] = {};
        this.offers[name].amount = ammount;
        this.offers[name].isOn = isOn;
    }

    hasDiscount() {
        return this.discount !== 0;
    }

    static findIndex(array,productCode) {
       return array.findIndex(item => item.productCode === productCode)
    }
    static find(array,productCode) {
        return array.find(item => item.productCode === productCode)
    }

    hasStock() {
        return this.stock !== 0;
    }

    static discountedPrice(price, discount, leadingZeros) {
        if(price === undefined ) return "";
        if(leadingZeros === undefined) leadingZeros = 3;
        if(!discount) return this.zeroPadNumber(price,leadingZeros);
        return this.zeroPadNumber((price - price * discount),leadingZeros)
    }


}


// WEBPACK FOOTER //
// ./src/assets/product.js